<template>
  <v-dialog
    v-model="open"
    width="700"
    scrollable
  >
    <v-form v-model="isValid">
      <v-card>
        <v-card-title
          class="headline primary darken-1"
          primary-title
        >
          Deactivating an employee
        </v-card-title>

        <v-card-subtitle class="py-0 mt-5">
          <p>Please select the reasons why the employee is not anymore part of your staff</p>
        </v-card-subtitle>
        <v-card-text class="">
          <v-chip-group v-model="reasons[0]" column active-class="primary--text" :multiple="false">
            <v-chip v-for="(mainReason, mainReasonKey) in this.availableReasons" :key="mainReasonKey" :value="mainReason" @click="clearFurtherReasons(1)">
              {{mainReason.reasonText}}
            </v-chip>
          </v-chip-group>
          <div v-if="reasons[0] && reasons[0].children">
            <v-divider></v-divider>
            <p>Please select a reason</p>
            <v-chip-group v-model="reasons[0].children && reasons[1]" column active-class="primary--text" :multiple="false">
              <v-chip v-for="(secondReason, secondReasonKey) in reasons[0].children" :key="secondReasonKey" :value="secondReason" @click="clearFurtherReasons(2)">
                {{secondReason.reasonText}}
              </v-chip>
            </v-chip-group>
          </div>
          <div v-if="reasons[0] && reasons[0].children && reasons[1] && reasons[1].children">
            <v-divider></v-divider>
            <p>Please select a reason</p>
            <v-chip-group v-model="reasons[0].children && reasons[1].children && reasons[2]" column active-class="primary--text" :multiple="false">
              <v-chip v-for="(thirdReason, thirdReasonKey) in reasons[1].children" :key="thirdReasonKey" :value="thirdReason">
                {{thirdReason.reasonText}}
              </v-chip>
            </v-chip-group>
          </div>


        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="!isValid" @click="submit()">
            Save
          </v-btn>
          <v-btn color="default" text @click="cancel()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

  import {employeeLeavingReasons} from "../../../constants/constants";

  export default {
    name: "employeeLeaving",
    props: ['selectedReasons'],
    data: () => ({
      open: false,
      isValid: false,
      reasons: [],
      availableReasons: employeeLeavingReasons
    }),
    mounted(){
      if (this.selectedReasons) {
        this.reasons = this.selectedReasons.map(e => ({...e}));
      }
    },
    watch: {
      selectedReasons: function(newVal, oldVal){
        if (newVal) {
          let reasonLevel = this.availableReasons;
          newVal.forEach((v, i) => {
            this.reasons[i] = reasonLevel.find(e => e.reasonId === v.reasonId)
            reasonLevel = this.reasons[i].children;
          })
        }
      }
    },
    methods: {
      openModal() {
        this.open = true;
      },
      cancel() {
        this.open = false;
        //this.$ga.event('Members', 'cancel', 'export');
      },
      submit() {
        this.$emit('employee-leaving-submit', {
          employeeLeavingReasons: this.reasons.map(e => ({
            reasonId: e.reasonId,
            reasonText: e.reasonText
          }))
        })
        this.open = false;
      },
      clearFurtherReasons(length) {
        this.reasons = this.reasons.slice(0, length)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Profiles/employeeLeaving.vue